import { merge } from "lodash-es";

const defaultToast = {
    icon: "exclamation-circle",
    message: "An unexpected error has occurred.",
    severity: "danger"
};

export const store = {
    state: {
        toast: null
    },

    setToast(toastObj) {
        if (toastObj) this.state.toast = merge(defaultToast, toastObj);
        else this.state.toast = defaultToast;
    },
    clearToast() {
        this.state.toast = null;
    }
};
